// extracted by mini-css-extract-plugin
module.exports = {"app-download-banner__qr-card":"AppDownloadBanner_app-download-banner__qr-card__Kbnmx","app-download-banner__qr-frame":"AppDownloadBanner_app-download-banner__qr-frame__ql8gz"};